/**
 * @category Internals
 */
export function createCredentials(source) {
    return {
        suid: source.uid,
        sgid: source.gid,
        euid: source.uid,
        egid: source.gid,
        groups: [],
        ...source,
    };
}
